import styled from 'styled-components';
import { Format } from '../../utils/styles-constants';
import { Link } from 'react-router';

const BreadcrumbThreadContainer = styled('div')`
	display: block;
`;

const BreadcrumbThread = styled('div')`
	display: flex;
	flex-flow: row wrap;
	align-items: center;
	line-height: 10px;
	padding: 0 10px;
	box-sizing: border-box;
	font-size: 13px;

	& > * {
		color: ${props => props.theme.primary.strongColor};
		text-decoration: none;
		line-height: 1.2;
	}

	& > span {
		font-weight: 600;
		letter-spacing: 0.5px;

		&:first-child {
			font-size: 20px;
		}
	}

	& > svg {
		height: 30px;
		width: 10px;
		margin: 0 5px;
		fill: ${props => props.theme.primary.strongColor};
	}
`;

const StyledLink = styled(Link)`
	position: relative;
	padding: 3px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;

	@media ${Format.Smartphone} {
		max-width: 70px;
	}

	@media ${Format.Tablet} {
		max-width: 200px;
	}
`;

export { BreadcrumbThreadContainer, BreadcrumbThread, StyledLink };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Breadcrumbs/styles.ts